export default "__VITE_ASSET__DQYtx9nU__"